import React from "react";
import Icon from "./Icon";

/* ---------------- Hero app preview ---------------- */
export const HeroApp = () => (
    <div className="clk-hero-visual">
        <div className="clk-window clk-app">
            <div className="clk-window-bar">
                <i /><i /><i />
                <span className="clk-window-url">claritick.com/tickets</span>
            </div>
            <div className="clk-app-body">
                <div className="clk-app-side">
                    <div className="clk-sb active"><Icon name="ticket" size={16} /></div>
                    <div className="clk-sb"><Icon name="inbox" size={16} /></div>
                    <div className="clk-sb"><Icon name="widget" size={16} /></div>
                    <div className="clk-sb"><Icon name="users" size={16} /></div>
                    <div className="clk-sb"><Icon name="chart" size={16} /></div>
                </div>
                <div className="clk-app-list">
                    <h5>Open tickets</h5>
                    <div className="clk-ticket-row active">
                        <div className="t1"><span className="t-title">Refund for order #1842</span><span className="t-time">2m</span></div>
                        <div className="t-prev">Hi team, I was charged twice…</div>
                        <span className="clk-pill open">Open</span>
                    </div>
                    <div className="clk-ticket-row">
                        <div className="t1"><span className="t-title">Login not working</span><span className="t-time">14m</span></div>
                        <div className="t-prev">Can't access my dashboard…</div>
                        <span className="clk-pill prog">In progress</span>
                    </div>
                    <div className="clk-ticket-row">
                        <div className="t1"><span className="t-title">Feature request</span><span className="t-time">1h</span></div>
                        <div className="t-prev">Would love dark mode…</div>
                        <span className="clk-pill closed">Closed</span>
                    </div>
                </div>
                <div className="clk-app-main">
                    <div className="clk-chat-head">
                        <span className="ch-title">Refund for order #1842</span>
                        <span className="clk-pill open">Open</span>
                    </div>
                    <div className="clk-bubble in">Hi team, I was charged twice for my last order. Can you help?</div>
                    <div className="clk-bubble out">Hi Sarah! So sorry about that. I can see the duplicate charge and I've issued a refund. 🙏</div>
                    <div className="clk-bubble in">That was fast, thank you!</div>
                    <div className="clk-bubble in" style={{ background: "transparent", paddingLeft: 0 }}>
                        <span className="clk-typing"><span /><span /><span /></span>
                    </div>
                </div>
            </div>
        </div>

        <div className="clk-float-chip fc1">
            <div className="fc-ic bg-cyan"><Icon name="mail" size={16} /></div>
            <div><div className="fc-t">New email → ticket</div><div className="fc-s">support@claritick.com</div></div>
        </div>
        <div className="clk-float-chip fc2">
            <div className="fc-ic bg-green"><Icon name="check" size={16} /></div>
            <div><div className="fc-t">Resolved in 4m</div><div className="fc-s">CSAT 4.9 / 5</div></div>
        </div>
        <div className="clk-float-chip fc3">
            <div className="fc-ic bg-violet"><Icon name="link" size={16} /></div>
            <div><div className="fc-t">Synced to Claritask</div><div className="fc-s">Task #318 created</div></div>
        </div>
    </div>
);

/* ---------------- Incoming email → ticket ---------------- */
export const InboxMockup = () => (
    <div className="clk-mk">
        <div className="clk-mk-head">
            <span className="mh-ic"><Icon name="mail" size={15} /></span>
            <span className="mh-t">Incoming inbox · support@claritick.com</span>
        </div>
        <div className="clk-mk-body">
            <div className="clk-mail">
                <div className="m-from">Sarah Connor</div>
                <div className="m-sub">Re: I was double charged on my order</div>
                <span className="m-arrow">→ Ticket #1842</span>
            </div>
            <div className="clk-flow"><span className="clk-line" /> auto-converted <span className="clk-line" /></div>
            <div className="clk-mail" style={{ borderColor: "transparent", background: "var(--clk-grad-soft)" }}>
                <div className="m-from">Ticket #1842 · assigned to Cole</div>
                <div className="m-sub">Reply threads stay in one clean conversation</div>
                <span className="m-arrow" style={{ background: "rgba(25,195,125,.14)", color: "#12a364" }}>Open</span>
            </div>
            <div className="clk-mail">
                <div className="m-from">Auto-confirmation sent</div>
                <div className="m-sub">"We received your message" + tracking link</div>
                <span className="m-arrow"><Icon name="check" size={12} /></span>
            </div>
        </div>
    </div>
);

/* ---------------- Embeddable widget ---------------- */
export const WidgetMockup = () => (
    <div className="clk-widget-stage">
        <div className="clk-widget-card">
            <div className="clk-widget-top">
                <h4>Contact support</h4>
                <p>We usually reply within a few minutes.</p>
            </div>
            <div className="clk-widget-form">
                <div className="clk-input">Full name</div>
                <div className="clk-input">you@company.com</div>
                <div className="clk-input area">How can we help?</div>
                <div className="clk-widget-btn">Send message</div>
            </div>
        </div>
        <div className="clk-launcher"><Icon name="chat" size={22} /></div>
    </div>
);

/* ---------------- Claritask integration ---------------- */
export const ClaritaskMockup = () => (
    <div className="clk-mk">
        <div className="clk-mk-head">
            <span className="mh-ic"><Icon name="link" size={15} /></span>
            <span className="mh-t">Claritask integration</span>
        </div>
        <div className="clk-mk-body">
            <div className="clk-sync">
                <div className="clk-sync-node">
                    <div className="sn-ic bg-cyan"><Icon name="ticket" size={20} /></div>
                    <div className="sn-t">Claritick</div>
                    <div className="sn-s">Ticket #1842</div>
                </div>
                <div className="clk-sync-mid">
                    <div className="clk-sync-dots"><i /><i /><i /></div>
                    <Icon name="link" size={18} />
                    <div className="clk-sync-dots"><i /><i /><i /></div>
                </div>
                <div className="clk-sync-node">
                    <div className="sn-ic bg-violet"><Icon name="check" size={20} /></div>
                    <div className="sn-t">Claritask</div>
                    <div className="sn-s">Task #318</div>
                </div>
            </div>
            <div className="clk-mail" style={{ marginTop: 16 }}>
                <div className="m-from">Status synced both ways</div>
                <div className="m-sub">Close the task → ticket updates automatically</div>
                <span className="m-arrow"><Icon name="check" size={12} /></span>
            </div>
        </div>
    </div>
);

/* ---------------- Scheduled summary email ---------------- */
export const SummaryMockup = () => (
    <div className="clk-mk">
        <div className="clk-mk-head">
            <span className="mh-ic"><Icon name="calendar" size={15} /></span>
            <span className="mh-t">Weekly summary · Monday 9:00 AM</span>
        </div>
        <div className="clk-mk-body">
            <div className="clk-mini-bars">
                <span style={{ height: "45%" }} /><span style={{ height: "70%" }} /><span style={{ height: "55%" }} />
                <span style={{ height: "85%" }} /><span style={{ height: "65%" }} /><span style={{ height: "95%" }} />
                <span style={{ height: "60%" }} />
            </div>
            <div className="clk-summary-row"><span className="sr-l">Tickets resolved</span><span className="sr-n" style={{ color: "#12a364" }}>128</span></div>
            <div className="clk-summary-row"><span className="sr-l">Avg. first response</span><span className="sr-n" style={{ color: "var(--clk-blue)" }}>6m 12s</span></div>
            <div className="clk-summary-row"><span className="sr-l">Open at week end</span><span className="sr-n" style={{ color: "#b8860b" }}>9</span></div>
            <div className="clk-summary-row"><span className="sr-l">Customer satisfaction</span><span className="sr-n" style={{ color: "var(--clk-gold)" }}>4.9 ★</span></div>
        </div>
    </div>
);

/* ---------------- Users & roles ---------------- */
const ROWS = [
    { n: "Cole Lockwood", r: "Admin", c: "bg-cyan", i: "CL" },
    { n: "Sara Park", r: "Agent", c: "bg-blue", i: "SP" },
    { n: "Tomás Kline", r: "Agent", c: "bg-violet", i: "TK" },
    { n: "Riya Nair", r: "Viewer", c: "bg-green", i: "RN" },
];
export const TeamMockup = () => (
    <div className="clk-mk">
        <div className="clk-mk-head">
            <span className="mh-ic"><Icon name="users" size={15} /></span>
            <span className="mh-t">Team · Users & roles</span>
        </div>
        <div className="clk-mk-body">
            {ROWS.map((row) => (
                <div key={row.n} className="clk-summary-row clk-team-row">
                    <span className="clk-team-person">
                        <span className={`clk-team-avatar fc-ic ${row.c}`}>{row.i}</span>
                        <span className="sr-l clk-team-name">{row.n}</span>
                    </span>
                    <span className="clk-pill open clk-team-role">{row.r}</span>
                </div>
            ))}
        </div>
    </div>
);
